import { useSchoolDistrictGetSchoolsForLoggedInUser } from "@crowdcoursing/api/openapi";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { useFeature } from "~hooks/useFeature";
import { VisitorManagementShellTemplate } from "~ui/templates/VisitorManagementShellTemplate/VisitorManagementShellTemplate";
import {
  EMPTY_GUID_BUBBLE_ID,
  getSchoolDisplayNameFromSchoolDtos,
} from "~ui/widgets/FrontOffice/frontOfficeSchoolsFromProfile";

import { QuickResponseModal } from "./QuickResponseModal";

export function VisitorManagementShell() {
  const isOrbit = useFeature("isOrbit");
  const logoHeight = isOrbit ? "3.5rem" : "2.5rem";
  const [quickResponseOpen, setQuickResponseOpen] = useState(false);
  const { pathname } = useLocation();
  const { schoolId } = useParams<{ schoolId: string }>();
  const isKioskLayout = pathname.endsWith("/kiosk");
  const { data: schoolDtos } = useSchoolDistrictGetSchoolsForLoggedInUser({
    pathParams: { bubbleId: EMPTY_GUID_BUBBLE_ID },
  });
  const schoolName = getSchoolDisplayNameFromSchoolDtos(schoolDtos, schoolId) ?? "School";

  return (
    <VisitorManagementShellTemplate
      isKioskLayout={isKioskLayout}
      logoHeight={logoHeight}
      quickResponseModal={
        <QuickResponseModal
          bubbleId={schoolId ?? ""}
          open={quickResponseOpen}
          onClose={() => setQuickResponseOpen(false)}
        />
      }
      schoolId={schoolId}
      schoolName={schoolName}
      onEmergency={() => setQuickResponseOpen(true)}
    />
  );
}
